import { DatePipe } from "@angular/common";
import { inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Lookup } from "src/app/core/interfaces";

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  private translate = inject(TranslateService);

  /**
   * Creates an array of Lookups from an enum.
   * @param object The enum to convert.
   * add translation for keys of the enum in LOOKUPS Object in i18n files
   * @returns An array of Lookups.
   */
  createLookupsFromEnum(object: any) {
    const options: Lookup[] = Object.keys(object)
      .filter((key) => isNaN(Number(key)))
      .map((key: any) => ({
        id: object[key],
        nameEn: this.translate.instant(`LOOKUPS.${key}`),
        nameAr: this.translate.instant(`LOOKUPS.${key}`),
        code: key,
      }));

    return options;
  }


  handleDateBeforeExporting(sheetDetails: { [k: string]: string }, data: any[]){
    const sheetColumnsValues = Object.keys(sheetDetails);

    const newArray = data.map((eachData, index) => {
      let eachRow = {};

      sheetColumnsValues.map((eachColumnValue) => {
        eachRow = {
          ...eachRow,
          ...{ " ": index + 1 },
          [sheetDetails[eachColumnValue]]: eachData[eachColumnValue] || '-',
        };
      });

      return eachRow;
    });
    return newArray;
  }

  
}
